module.exports = __webpack_public_path__ + "fonts/Lato-Italic.f28f2d64.woff";